<div class="title">
  <mwp-text-translate text="Select Checkout Method" jsonKey="OTPTitle" />
</div>
<div class="content">
  <div class="message-card blue-fill mb-3">
    <mwp-text-translate text="Benefit Counselor, please verify the employee agrees to the terms and conditions listed below. Once you have received the employee's agreement to the terms and conditions, please choose the authorize method below for them to receive the verification code. The verification code is required for checkout." jsonKey="OTPInstructions" />
  </div>
  @if (!otpComplete) {
    <div class="d-inline-flex justify-content-between w-100 mb-4">
      @for (otp of otpTypes | enumKeys; track otp) {
        <button class="mwp-button" (click)="otpSelection(otp)">
          <mwp-text-translate  [text]="otp.value" [jsonKey]="otp.value" />
        </button>
      }
    </div>
  }
  @if (displayForm) {
    <div class="mb-3">
      <form [formGroup]="otpForm" class="row">
        @if (selectedOTPType == otpTypes.voiceSignature) {
          <div class="col-12 mb-3">
            <mwp-text-translate text="I" jsonKey="ibeforeName" />
            {{ agentName }},
            <mwp-text-translate text="agree that by entering my system password below I am certifying that I have supporting documentation and/or a voice recording that will corroborate that I have received authorization from " jsonKey="OTPInstructionsPart1" />
            {{ memberName }}
            <mwp-text-translate text="to submit this enrollment session in its current state, I have verified their identity, I have verified their demographic information, I have reviewed all plans offered, and I have checked all benefits for accuracy. Entering my password below further acts as my electronic signature to be used on any applications generated from this process, and will complete the enrollment session for this employee." jsonKey="OTPInstructionsPart2" />
          </div>
        }
        <div>
          @if (!otpComplete) {
            <div class="d-inline-flex align-items-center">
              @if (!otpInputIsPassword && !otpInputIsVerifyCode) {
                <div class="me-3">
                  <mwp-input [form]="otpForm" [labelName]="otpLabelName" [nameForControl]="otpInputName" [maskType]="otpMaskType" />
                </div>
              }
              @if (otpInputIsPassword && !otpInputIsVerifyCode) {
                <div class="me-3">
                  <mwp-input [form]="otpForm" [labelName]="otpLabelName" [nameForControl]="otpInputName" [maskType]="otpMaskType" inputType="password" />
                </div>
              }
              @if (disaplyOTPCallerIDINput && !otpInputIsVerifyCode) {
                <div class="me-3">
                  <mwp-input [form]="otpForm" labelName="Phone Number" [nameForControl]="otpInputMemberCallerId" [maskType]="maskType.phone" />
                </div>
              }
              @if (otpInputIsVerifyCode) {
                <div class="me-3">
                  <mwp-verify-code [form]="otpForm" [useFixedWidth]="true" [nameForRadioControl]="otpInputVerifyCodeName" />
                </div>
              }
              <div [ngClass]="otpInputIsVerifyCode ? 'ms-3': ''">
                <button class="mwp-button" [disabled]="otpForm.invalid" (click)="otpCodeRequestSubmit()">
                  <mwp-text-translate  [text]="otpButtonName" [jsonKey]="otpButtonName" />
                </button>
              </div>
            </div>
          }
          @if (otpComplete) {
            <div class="col-12 message-card green px-3 py-2">
              <span>
                <b>
                  <mwp-text-translate text="Verification Successful!" jsonKey="verifySuccessful" />
                </b>
                <mwp-text-translate text="You may now click confirm below to complete the checkout process." jsonKey=" verifySuccessfulMessage" />
              </span>
            </div>
          }
        </div>
      </form>
    </div>
  }
  @if (displayVerifyOTPForm) {
    <div class="mb-3">
      <form [formGroup]="verifyOtpForm">
        <div class="d-inline-flex align-items-center">
          @if (!otpComplete) {
            <div>
              <mwp-verify-code [form]="verifyOtpForm" [useFixedWidth]="true" nameForRadioControl="code" />
            </div>
          }
          @if (!otpComplete) {
            <div class="ms-5">
              <button class="mwp-button" [disabled]="verifyOtpForm.invalid" (click)="verifyCode()">
                <mwp-text-translate text="Verify Code" jsonKey=" verifyCode" />
              </button>
            </div>
          }
          @if (otpComplete) {
            <div class="col-12 message-card green px-3 py-2">
              <span>
                <b>
                  <mwp-text-translate text="Verification Successful!" jsonKey="verifySuccessful" />
                </b>
                <mwp-text-translate text="You may now click continue below to complete the checkout process." jsonKey="verifySuccessfulMessage" />
              </span>
            </div>
          }
        </div>
      </form>
    </div>
  }
  @if (displayError) {
    <div>
      <div class="mb-3 error">
        <span>{{ registrationErrorMessage }}</span>
      </div>
      <div class="d-inline-flex">
        <button class="mwp-button-secondary me-3" (click)="cancelError()">
          <mwp-text-translate text="Back" jsonKey="Back" />
        </button>
        <button class="mwp-button" (click)="reloadFormToEmail()">
          <mwp-text-translate text="Verify By Email" jsonKey="verifyByEmail" />
        </button>
      </div>
    </div>
  }
  <div class="mb-3">
    <span>
      <mwp-text-translate text="Employee agrees to: You authorize your elections for the benefits and/or benefit requests presented on the preceding Summary page. Further, you certify that all eligibility and/or underwriting questions answered by you during this enrollment session are true and accurate, you authorize your employer to take any payroll deductions required for the options selected, and you agree with all carrier/vendor disclosures, terms, and/or conditions for coverage and/or underwriting presented." jsonKey="otpAcknowledgement" />
    </span>
  </div>
</div>